export default {
  name: 'radio',
  label: '单选框组',
  icon: 'el-icon-circle-check',
  config: [{
    xtype: 'radio',
    options: {
      label: '控件风格',
      name: 'radioStyle',
      radioStyle: 'button',
      size: 'small',
      options: [{
        label: '常规',
        value: ''
      }, {
        label: '按钮',
        value: 'button'
      }]
    }
  }, {
    // 可修改的配置选项
    xtype: 'option-list',
    options: {
      label: '选项列表',
      name: 'options',
      default: [{
        label: '选项1',
        value: '选项1'
      }, {
        label: '选项2',
        value: '选项2'
      }, {
        label: '选项3',
        value: '选项3'
      }]
    }
  }]
};